/**
 * GLDN Cart Drawer Auto-Open
 *
 * Opens the cart drawer every time a product is added to cart, matching
 * the live site behavior (which has `settings.auto_open_cart_drawer`
 * effectively on). Horizon's `<cart-drawer-component>` only auto-opens
 * if its `auto-open` attribute is set, which is gated by the theme
 * setting; we force the behavior on at the script layer so it's
 * consistent regardless of the setting state.
 *
 * Originally mobile-only; expanded to all viewports to match live
 * parity (personalized items already opened the drawer on every
 * viewport via the personalizer's own logic — non-personalized adds
 * needed the same treatment for consistent UX).
 */
(function () {
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    // Horizon's cart-drawer-component exposes open() which routes through
    // its DialogComponent.showDialog. Safe to call even if the dialog is
    // already open (no-op).
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    }
  }

  // CartAddEvent and CartUpdateEvent share the same event name in Horizon
  // ('cart:update'). Horizon's cart-drawer handler doesn't distinguish
  // between them either — showDialog is a no-op if the dialog is already
  // open, so quantity-change events on an already-open drawer are
  // harmless. Only adds-from-PDP trigger the actual open.
  document.addEventListener('cart:update', function (e) {
    // Skip events from cart-items-component itself (qty change inside the
    // drawer). Add-from-PDP events come from product-form-component.
    var src = e && e.detail && (e.detail.source || (e.detail.data && e.detail.data.source));
    if (src === 'cart-items-component') return;
    openCartDrawer();
  });
})();
